export const getWithExpiry = async (): Promise<any> => {
  const itemStr = sessionStorage.getItem("cimaSuccessful");
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    sessionStorage.removeItem("cimaSuccessful");
    sessionStorage.removeItem("cimaValid");
    return "false";
  }
  return item.value;
};
